import { c as _c } from "react/compiler-runtime";
import { track } from "@opensea/analytics";
import { useChains } from "@opensea/app-kit";
import { useAccount } from "@opensea/wallet";
import { setContext } from "@sentry/nextjs";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { useAccount as useWagmiAccount } from "wagmi";
import { useIsWagmiStateTrackingEnabled } from "@/hooks/use-flags";
import { useFlowTracking } from "./use-flow-tracking";
import { useSwitchChainTracking } from "./use-switch-chain-tracking";
import { useWalletTracking } from "./use-wallet-tracking";
export function WalletAnalyticsHandler() {
  const $ = _c(23);
  useWalletTracking();
  useFlowTracking();
  useSwitchChainTracking();
  const {
    chains
  } = useChains();
  const {
    address,
    chainId,
    connectorId,
    isConnecting,
    authenticated,
    ready
  } = useAccount();
  let t0;
  let t1;
  if ($[0] !== address || $[1] !== authenticated || $[2] !== chainId || $[3] !== chains || $[4] !== connectorId || $[5] !== isConnecting || $[6] !== ready) {
    t0 = () => {
      setContext("wallet", {
        address,
        chainId,
        connectorId,
        isConnecting,
        authenticated,
        ready
      });
      setContext("appChains", {
        chains: chains.map(_temp)
      });
    };
    t1 = [address, chainId, connectorId, isConnecting, authenticated, ready, chains];
    $[0] = address;
    $[1] = authenticated;
    $[2] = chainId;
    $[3] = chains;
    $[4] = connectorId;
    $[5] = isConnecting;
    $[6] = ready;
    $[7] = t0;
    $[8] = t1;
  } else {
    t0 = $[7];
    t1 = $[8];
  }
  useEffect(t0, t1);
  const wagmiAccount = useWagmiAccount();
  const trackWagmiState = useIsWagmiStateTrackingEnabled();
  let t2;
  if ($[9] !== trackWagmiState || $[10] !== wagmiAccount.address || $[11] !== wagmiAccount.chainId || $[12] !== wagmiAccount.connector?.id || $[13] !== wagmiAccount.isConnected || $[14] !== wagmiAccount.isConnecting || $[15] !== wagmiAccount.isDisconnected || $[16] !== wagmiAccount.isReconnecting || $[17] !== wagmiAccount.status) {
    t2 = () => {
      const wagmiData = {
        address: wagmiAccount.address,
        chainId: wagmiAccount.chainId,
        connectorId: wagmiAccount.connector?.id,
        isConnecting: wagmiAccount.isConnecting,
        isReconnecting: wagmiAccount.isReconnecting,
        isDisconnected: wagmiAccount.isDisconnected,
        isConnected: wagmiAccount.isConnected,
        status: wagmiAccount.status
      };
      if (trackWagmiState) {
        track("Wagmi Account", wagmiData);
      }
      setContext("wagmi", wagmiData);
    };
    $[9] = trackWagmiState;
    $[10] = wagmiAccount.address;
    $[11] = wagmiAccount.chainId;
    $[12] = wagmiAccount.connector?.id;
    $[13] = wagmiAccount.isConnected;
    $[14] = wagmiAccount.isConnecting;
    $[15] = wagmiAccount.isDisconnected;
    $[16] = wagmiAccount.isReconnecting;
    $[17] = wagmiAccount.status;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  let t3;
  if ($[19] !== trackWagmiState || $[20] !== wagmiAccount) {
    t3 = [trackWagmiState, wagmiAccount];
    $[19] = trackWagmiState;
    $[20] = wagmiAccount;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  useEffect(t2, t3);
  let t4;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  useEffect(_temp2, t4);
  return null;
}
function _temp2() {
  Cookies.set("os2AccessEx", "Wdr6yywSUvHzIWYeBybn17MOdxKRbbhM", {
    path: "/",
    domain: "opensea.io",
    sameSite: "lax",
    secure: true,
    expires: 365
  });
}
function _temp(chain) {
  return chain.name;
}